// 09-10 (Pau aprobó la maqueta «letrero de sala con resumen»): junto al nombre de cada sala, lo más urgente que le
// toca a Pau en ella con cuántos (la misma insignia que la lista) y cuántos trabajan, en gris. PURO: las cuentas
// salen de resumenCabecera (marco/situacion.ts), así el letrero y la cabecera de la lista nunca discrepan.
import type { ContratadoDTO } from '../compartido/vocabulario';
import { grupoDelContratado, resumenCabecera, type Pieza, type SantiPorAgente } from '../marco/situacion';

export interface ResumenLetrero {
  /** Lo más urgente que le toca a Pau en la sala (1 → 2 → problema suyo → 3), con su cuenta; null si nada. */
  urgente: (Pieza & { c: ContratadoDTO }) | null;
  /** Trabajando (y llegando), como «N trabajando» de la cabecera. */
  trabajando: Pieza | null;
}

export function resumenLetrero(lista: readonly ContratadoDTO[], santi?: SantiPorAgente): ResumenLetrero {
  const r = resumenCabecera(lista, santi);
  const pieza = r.teToca[0];
  // El primero de ese grupo: su insignia (el problema de Pau va en rojo, no en arena).
  const c = pieza ? lista.find((x) => grupoDelContratado({ situacion: x.situacion, pide: x.pide }, santi?.get(x.agentId)) === pieza.grupo) : undefined;
  return {
    urgente: pieza && c ? { ...pieza, c } : null,
    // `aparte` empieza por «N trabajando» si hay alguien trabajando (o llegando); si no, por otra cosa.
    trabajando: lista.some((x) => x.situacion === 'trabajando' || x.situacion === 'llegando') ? r.aparte[0]! : null,
  };
}
